<template>
  <div class="find_account_wrap">
    <v-text-field
        v-model="query"
        placeholder="Find existing artist account"
        hide-details
        dense
        clearable
        :loading="isLoading"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ArtistSearchInput',
  props: {
    value: String
  },
  data() {
    return {
      query: this.value || '',
      debounceTimer: null,
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      searchResults: 'SEARCH_ARTISTS_RESULT'
    })
  },
  watch: {
    query(val) {
      this.$emit('input', val);
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.searchArtists(val);
      }, 400);
    },
    value(newVal) {
      if (newVal !== this.query) {
        this.query = newVal;
      }
    },
    searchResults: {
      handler(results) {
        this.$emit('search-results', results);
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions(['SEARCH_ARTISTS']),
    async searchArtists(name) {
      if (!name || name.length < 2) {
        this.$emit('search-results', []);
        return;
      }

      this.isLoading = true;

      try {
        await this.SEARCH_ARTISTS({ name });
      } catch (err) {
        console.error('SEARCH_ARTISTS error', err);
        this.$emit('search-results', []);
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.find_account_wrap {
  margin-top: -14px;
  margin-bottom: 8px;
}

.v-input {
  border: 1px solid #282C47;
  border-radius: 5px;
  padding-left: 16px;
  background: #040A18;
  margin-top: 0;
  padding-top: 0;
}
</style>
